"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
var React = require("react");
var ReactDOM = require("react-dom");
var ToolTip_1 = require("../tooltip/ToolTip");
var l = require("lenovo");
var utils_1 = require("../tooltip/utils");
var t = l.Translator.translate;
// this tooltip only for dcg.
var limitRealms = ['dcg'];
var titleHTML = "" + t('severity guide|Severity Guide');
var descriptionHTML = "<p>\n      <strong>" + t('critical or urgent|Critical or Urgent') + ":</strong>\n      <span> " + t('critical or urgent description|Unable to use the solution resulting in a critical impact to operations. Includes high severity vulnerabilities.') + "</span>\n    </p>\n    <p>\n      <strong>" + t('recommended or suggested|Recommended or Suggested') + ":</strong>\n      <span>" + t('recommended or suggested description|The solution can be used with some functional restrictions resulting in minimal impact to business. Includes medium and low severity vulnerabilities.') + "</span>\n    </p>\n    <p>\n      <strong>" + t('initial|Initial') + ":</strong>\n      <span>" + t('initial release description|Initial release of the solution.') + "</span>\n    </p>";
var Title = function () { return (React.createElement("strong", { dangerouslySetInnerHTML: { __html: titleHTML } })); };
var Description = function () { return (React.createElement("div", { dangerouslySetInnerHTML: { __html: descriptionHTML } })); };
var SeverityTooltip = function (props) {
    // for not destroying the structure of original DOM, must to use []. Even many typescript errors come out by using [].
    // Note: Do not use <></> or <React.Fragment></React.Fragment>, the React version which we used didn't support it.
    if (!utils_1.validRealms(limitRealms))
        return [props.children];
    return React.createElement(ToolTip_1.default, { title: React.createElement(Title, null), description: React.createElement(Description, null), method: ToolTip_1.ToolTipMethods.hover, defaultTriggerTarget: props.triggerTarget, iconClass: 'icon-lenovo-drivers-info-icon severity-guide', appendIcon: true }, props.children);
};
exports.default = SeverityTooltip;
/**
 * <Important>
 * Only for the element which contain no special event, such as a pure html element.
 * This function will cause the htmlElement losing its own events.
 * @param el {HTMLElement}
 */
exports.load = function (el) {
    if (!utils_1.validRealms(limitRealms))
        return;
    ReactDOM.render(
    // @ts-ignore
    React.createElement(SeverityTooltip, { triggerTarget: el }, el.innerHTML
        ? React.createElement("span", { dangerouslySetInnerHTML: { __html: el.innerHTML } })
        : null), el);
};
/**
 * export a jquery popover event.
 * @param $jqDom {$}
 * @return {$}
 */
exports.jQueryLoad = function ($jqDom) {
    if (!utils_1.validRealms(limitRealms))
        return;
    // costume css style for severity-tooltip
    $('style[data-name="severityToolTipExtraClass"]').remove();
    $('head').append("\n    <style data-name=\"severityToolTipExtraClass\" type=\"text/css\">\n      .popover.severity-tooltip {\n        max-width: unset;\n      }\n    </style>");
    $jqDom.css({
        cursor: 'pointer',
    }).popover({
        content: "<div class=\"global-tooltip\">\n                <div class='tooltip-container'>\n                  <div class='tooltip-title'>\n                   <strong>" + titleHTML + "</strong>\n                  </div>\n                  <div class='tooltip-body'>\n                    " + descriptionHTML + "\n                  </div>\n                </div>\n            </div>",
        trigger: 'hover',
        html: true,
        placement: 'top',
        container: 'body',
    }).on('inserted.bs.popover', function () {
        // `inserted` is the time of that the tooltip is generated, but all css style is waiting for calculating.
        var toolTipID = $jqDom.attr('aria-describedby');
        if (!toolTipID)
            return false;
        var $toolTip = $("#" + toolTipID);
        $toolTip.addClass('severity-tooltip');
    });
    return $jqDom;
};
